// frontend/src/reducers/session_errors_reducer.js
import {
  RECEIVE_SESSION_ERRORS,
  RECEIVE_CURRENT_USER,
} from '../actions/session_actions';

const _nullErrors = {};

const SessionErrorsReducer = (state = _nullErrors, action) => {
  Object.freeze(state);

  switch (action.type) {
    case RECEIVE_SESSION_ERRORS:
      // Normalize errors into an object so the UI can always read it
      if (!action.errors) return _nullErrors;

      if (Array.isArray(action.errors)) {
        const out = {};
        action.errors.forEach((msg, idx) => {
          out[idx] = msg;
        });
        return out;
      }

      if (typeof action.errors === 'object') {
        // e.g. { approval: "Your account is pending approval..." }
        return action.errors;
      }

      // Single string
      return { message: action.errors };

    case RECEIVE_CURRENT_USER:
      // Successfully logged in or signed up → clear session errors
      return _nullErrors;

    default:
      return state;
  }
};

export default SessionErrorsReducer;
